import { useEffect } from 'react'

const UniChatBox = () => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src =
      'https://chatbot.uniuni.com:10023/embed/anythingllm-chat-widget.min.js'
    script.async = true

    script.setAttribute('data-window-width', '30%')
    script.setAttribute('data-window-height', '75%')
    script.setAttribute('data-button-color', '#43BD99')
    script.setAttribute('data-chat-icon', 'chatBubble')
    script.setAttribute('data-user-bg-color', '#43BD99')
    script.setAttribute('data-no-sponsor', 'true')
    script.setAttribute(
      'data-greeting',
      "Hi! I'm here to assist you. How can I help you today?"
    )
    script.setAttribute('data-show-thoughts', 'true')
    script.setAttribute('data-username', 'Me')
    script.setAttribute('data-assistant-name', 'UniUni Helper')
    script.setAttribute('data-sponsor-link', 'https://www.uniuni.com/')
    script.setAttribute('data-sponsor-text', 'UniLab')
    script.setAttribute(
      'data-assistant-icon',
      'https://chatbot.uniuni.com:5001/static/images/data-brand-image-url.svg'
    )
    script.setAttribute(
      'data-chat-icon',
      'https://chatbot.uniuni.com:5001/static/images/fluent_bot-add-20-filled.s'
    )
    script.setAttribute(
      'data-brand-image-url',
      'https://chatbot.uniuni.com:5001/static/images/blank.png'
    )
    script.setAttribute('data-embed-id', '2da3a377-7002-49dc-b67e-cde06f18520e')
    script.setAttribute(
      'data-base-api-url',
      'https://chatbot.uniuni.com:10023/api/embed'
    )

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return null
}

export default UniChatBox
